import React from 'react'
import styled from '@emotion/styled'
import { colors, spacing } from '@mobi/component-library/Foundations'
import { AnimatedHeightToggle } from '@mobi/component-library/Misc/AnimatedHeightToggle'
import { ExpandableContentButton } from '../FooterButtons/FooterButtons'

export const Footer: React.FC<FooterProps> = ({
  leftSection,
  rightSection,
  expandableContent,
  expandableText,
}) => {
  const [isExpanded, setIsExpanded] = React.useState(false)

  const toggleExpanded = () => setIsExpanded(curr => !curr)

  return (
    <WrapperStyled data-testid='BetCard.Footer'>
      <div>
        <div>
          {expandableContent && (
            <ExpandableContentButton
              onClick={() => toggleExpanded()}
              isExpanded={isExpanded}
              text={expandableText}
            />
          )}

          {leftSection}
        </div>

        <div>{rightSection}</div>
      </div>

      <AnimatedHeightToggle isExpanded={isExpanded}>{expandableContent}</AnimatedHeightToggle>
    </WrapperStyled>
  )
}

// ======
// Styles
// ======

const WrapperStyled = styled.div({
  '> div:first-of-type': {
    boxSizing: 'border-box',
    display: 'flex',
    justifyContent: 'space-between',
    gap: spacing.sm,
    height: '4rem',
    paddingTop: spacing.smx1,
    borderTop: '0.5px solid ' + colors.neutral[200],

    '> div': {
      display: 'flex',
      alignItems: 'center',
      gap: spacing.smx2,
    },
  },
})

// =====
// Types
// =====

type FooterProps = {
  leftSection?: React.ReactNode
  rightSection?: React.ReactNode
} & (
  | { expandableContent?: never; expandableText?: never }
  | { expandableContent?: React.ReactNode; expandableText?: string }
)
